var map = {
	"./social-500px.svg": 70,
	"./social-dribbble.svg": 71,
	"./social-facebook.svg": 72,
	"./social-github.svg": 73,
	"./social-google.svg": 74,
	"./social-instagram.svg": 75,
	"./social-odnoklassniki.svg": 76,
	"./social-rediit.svg": 77,
	"./social-stackoverflow.svg": 78,
	"./social-steam.svg": 79,
	"./social-twitch.svg": 80,
	"./social-twitter.svg": 81,
	"./social-vkontakte.svg": 82,
	"./social-windows.svg": 83,
	"./social-yahoo.svg": 84
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars ^\.\/social\-.*\.svg$
// module id = 69
// module chunks = 0